/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Region } from '../models/Region';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RegionService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns Region
     * @throws ApiError
     */
    public regionGet(): Observable<Array<Region>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/regions',
        });
    }
}
